import React, { FC, memo } from 'react';
import { Text } from '@wix/design-system';
import styles from './Header.scss';

type Props = {
  currentStepIndex: number;
  totalSteps: number;
};

export const HeaderProgressCounter: FC<Props> = memo(({ currentStepIndex, totalSteps }) => {
  return (
    <div className={styles.headerProgressCounter}>
      <Text secondary size="small">
        {currentStepIndex} / {totalSteps}
      </Text>
    </div>
  );
});
